import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import QuizProgressBar from './QuizProgressBar';
import QuizIntro from './QuizIntro';
import QuizQuestion from './QuizQuestion';
import QuizOutro from './QuizOutro';
import { candleTypes } from './TributeCreator';

function QuizPage() {
    const { id } = useParams();
    const [quiz, setQuiz] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');
    const [phase, setPhase] = useState('loading');
    const [currentIndex, setCurrentIndex] = useState(0);
    const [score, setScore] = useState(0);
    const [bucket, setBucket] = useState(null);

    useEffect(() => {
        const fetchQuiz = async () => {
            setLoading(true);
            setError('');
            try {
                const response = await fetch(`/api/quiz/${id}`);
                if (!response.ok) {
                    if (response.status === 404) {
                        setError('Nie znaleziono quizu. Za chwilę nastąpi przekierowanie.');
                        setTimeout(() => { window.location.href = '/'; }, 3000);
                        return;
                    }
                    throw new Error(`Błąd HTTP: ${response.status}`);
                }
                const data = await response.json();
                setQuiz(data);
                if (data.introText && data.introText.trim() !== '') {
                    setPhase('intro');
                } else {
                    setPhase('question');
                    setCurrentIndex(0);
                    setScore(0);
                }
            } catch (e) {
                setError(e.message || 'Nie udało się załadować quizu.');
            } finally {
                setLoading(false);
            }
        };
        fetchQuiz();
    }, [id]);

    const handleStart = () => {
        setPhase('question');
        setCurrentIndex(0);
        setScore(0);
    };

    const handleAnswer = (question, answerNumber) => {
        const points = answerNumber - 1;
        const newScore = score + points;
        setScore(newScore);

        fetch(`/api/quiz/question/${question.id}/answer`, { method: 'POST' }).catch(() => {});

        if (currentIndex + 1 < quiz.questions.length) {
            setCurrentIndex(currentIndex + 1);
        } else {
            finishQuiz(newScore);
        }
    };

    const finishQuiz = (finalScore) => {
        fetch(`/api/quiz/${quiz.id}/complete`, { method: 'POST' }).catch(() => {});
        const bucketSize = quiz.maxScore / 11.0;
        const computedBucket = quiz.maxScore > 0 ? Math.min(11, Math.floor(finalScore / bucketSize) + 1) : 1;
        setBucket(computedBucket);
        if (quiz.outroText && quiz.outroText.trim() !== '') {
            setPhase('outro');
        } else {
            window.location.href = `/?bucket=${computedBucket}#tribute-creator`;
        }
    };

    const handleRedirect = () => {
        window.location.href = `/?bucket=${bucket}#tribute-creator`;
    };

    if (loading) {
        return <div className="quiz-page"><h2>Ładowanie quizu...</h2></div>;
    }

    if (error) {
        return <div className="quiz-page quiz-error"><h2>{error}</h2></div>;
    }

    const progress = phase === 'intro' ? 0 : phase === 'outro' ? 100 : (currentIndex / quiz.questions.length) * 100;

    return (
        <div className="quiz-page">
            <h1 className="quiz-title">{quiz.name}</h1>
            <QuizProgressBar progress={progress} />
            <div className="quiz-view">
                {phase === 'intro' && <QuizIntro introText={quiz.introText} onStart={handleStart} />}
                {phase === 'question' && quiz.questions.length > 0 && (
                    <QuizQuestion
                        question={quiz.questions[currentIndex]}
                        onAnswer={handleAnswer}
                    />
                )}
                {phase === 'outro' && (
                    <QuizOutro
                        outroText={quiz.outroText}
                        candle={bucket ? candleTypes[bucket - 1] : null}
                        onRedirect={handleRedirect}
                    />
                )}
            </div>
        </div>
    );
}

export default QuizPage;
